import appointmentActions from 'features/appointment/services/actions';
import { useState } from 'react';
import { ICustomerItemData } from 'services/shop/types/customer';
import { useAppDispatch } from 'store/hooks';
import CustomerSearchInputV2 from 'widgets/Customer/CustomerSearchInputV2';

type InputSearchProps = {};
const InputSearch = ({ }: InputSearchProps) => {
  const dispatch = useAppDispatch();
  const [selected, setSelected] = useState<ICustomerItemData | null>();

  const handleChange = (data: ICustomerItemData | null) => {
    setSelected(data);
    dispatch(appointmentActions.setTableParams({ customerId: data?.id }));
  };
  return (
    <CustomerSearchInputV2 value={selected} onChange={handleChange} />
  );
};

export default InputSearch;
